import React from 'react';
import { Container, Button, Modal, Popup, Form, Icon, Input, Dropdown } from 'semantic-ui-react'
import DataTable from 'react-data-table-component';
import { useSelector, useDispatch } from 'react-redux';
import {
   getAssetList,
   saveAssetList,
   updateAssetList,
   statusAssetList,
   deleteAssetList
} from '../Redux/Actions/AssetsListAction'
import { Formik } from 'formik'
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import ConfirmModal from '../Components/ConfirmModal';
import TableLoader from '../Components/TableLoader';
import { getAssets } from '../Redux/Actions/AssetsAction';

const AssetList = () => {

   const inputRef = React.useRef();
   const dispatch = useDispatch()
   React.useEffect(() => {
      dispatch(getAssetList(toast, authToken))
      dispatch(getAssets(toast, authToken))
      inputRef.current && inputRef.current.focus();
   }, [])

   const authToken = localStorage.getItem('accessToken');
   const [openModal, setOpenModal] = React.useState(false)
   const [openConfirm, setOpenConfirm] = React.useState(false)
   const [actionMode, setActionMode] = React.useState('');
   const [rowData, setRowData] = React.useState([]);
   const [searchInput, setSearchInput] = React.useState('');
   const loadingData = useSelector(state => state.loadingReducer.loadingPayload);
   const isPageLoading = loadingData && loadingData.string === 'list' ? loadingData.status : false

   const assetListData = useSelector(state => state.assetsReducer.assetListPayload)
   // const filteredItems = assetListData && assetListData
   const filteredItems = assetListData && assetListData.filter(item => (
      item.asset.name.toLowerCase().includes(searchInput.toLowerCase())
   ));

   const assetNameData = useSelector(state => state.assetsReducer.assetsPayload)
   const assetNameList = assetNameData && assetNameData.map(item => {
      return {
         key: item.id,
         value: item.id,
         text: item.name
      }
   })
   // console.log(assetNameList);

   const searchComponent = <Input icon='search' placeholder='Search..' value={searchInput} onChange={e => setSearchInput(e.target.value)} />

   const actions = <React.Fragment>
      <Button
         primary
         onClick={() => (setOpenModal(true), setActionMode('Add'))}>
         <Icon name='add circle' />
         Add New
      </Button>
   </React.Fragment>;

   const conditionalRowStyles = [
      {
         when: row => row.status === 'I',
         style: {
            backgroundColor: '#f3f3f3',
            color: 'rgb(132 132 132 / 87%)'
         },
      }
   ]

   const columns = [
      {
         name: 'Asset Name',
         selector: 'asset.name',
         sortable: true,
      },
      {
         name: 'Qr Code',
         selector: 'qr_code',
         sortable: true,
      },
      {
         name: 'Action',
         sortable: false,
         allowOverflow: true,
         button: true,
         width: '56px',
         right: true,
         cell: (data) =>
            <Popup
               style={{ padding: 0 }}
               position='left center'
               trigger={<Button color='basic' icon="ellipsis vertical" />}
               on='click'>
               <Button.Group vertical labeled icon color='basic' style={{ border: 0 }}>
                  <Button
                     icon='edit'
                     content='Edit'
                     onClick={() => (
                        setRowData(data),
                        setOpenModal(true),
                        setActionMode('Edit'))} />
                  <Button
                     icon='trash alternate outline'
                     content='Delete'
                     onClick={() => (
                        setOpenConfirm(true),
                        setRowData(data),
                        setActionMode('Delete'))} />
                  {data.status === 'I' ?
                     <Button icon='lock open' content='Active'
                        onClick={() => (
                           setOpenConfirm(true),
                           setRowData(data),
                           setActionMode('Active'))} /> :
                     <Button icon='lock' content='InActive'
                        onClick={() => (
                           setOpenConfirm(true),
                           setRowData(data),
                           setActionMode('InActive'))} />}
               </Button.Group>
            </Popup>
      },
   ];

   const customStyles = {
      table: {
         minHeight: '400px'
      },
      headCells: {
         style: {
            backgroundColor: 'rgb(33 133 208)',
            color: '#FFF',
            fontSize: '16px',
            fontWeight: '700',
         },
      }
   }

   const userSchema = Yup.object().shape({
      asset_id: Yup.string()
         .required('Asset name is required'),
      qr_code: Yup.string()
         .min(2, 'Qr Code is too short!')
         .max(50, 'Qr Code is too Long!')
         .required('Qr Code is required')
   });


   return (
      <div>
         <Container fluid>
            <DataTable
               title='Asset List Management'
               columns={columns}
               customStyles={customStyles}
               data={filteredItems}
               actions={actions}
               pagination={true}
               paginationResetDefaultPage={true}
               conditionalRowStyles={conditionalRowStyles}
               persistTableHead
               subHeader
               subHeaderComponent={searchComponent}
               progressPending={isPageLoading}
               progressComponent={<TableLoader />}
            />
            <Modal open={openModal} size='tiny'>
               <Formik
                  enableReinitialize
                  initialValues={{
                     id: actionMode === "Add" ? "" : rowData.id,
                     asset_id: actionMode === "Add" ? "" : rowData.asset_id,
                     qr_code: actionMode === "Add" ? "" : rowData.qr_code,
                  }}
                  validationSchema={userSchema}
                  onSubmit={(values, actions) => {
                     dispatch(saveAssetList(values, actions, setOpenModal, actionMode, toast, authToken))
                  }}>
                  {({
                     values,
                     errors,
                     touched,
                     handleChange,
                     handleBlur,
                     isSubmitting,
                     handleSubmit,
                     setFieldValue
                  }) => (
                     <React.Fragment>
                        <Modal.Header>{actionMode === "Edit" ? 'Edit User' : 'Create user'}</Modal.Header>
                        <Modal.Content>
                           <Form id="myForm">
                              <Form.Field>
                                 <label>Asset Name</label>
                                 <Dropdown
                                    error={errors.asset_id && touched.asset_id ? true : false}
                                    options={assetNameList}
                                    placeholder='Select asset name'
                                    selection
                                    search
                                    name="asset_id"
                                    value={values.asset_id}
                                    onChange={(e, { name, value }) => {
                                       setFieldValue('asset_id', value)
                                    }}
                                 />
                              </Form.Field>
                              <Form.Input
                                 autoFocus
                                 error={errors.qr_code && touched.qr_code ? { content: errors.qr_code } : false}
                                 fluid
                                 label='Asset qr code'
                                 placeholder='Asset qr code'
                                 innerRef={inputRef}
                                 type="text"
                                 value={values.qr_code}
                                 onChange={handleChange('qr_code')}
                              />
                           </Form>
                        </Modal.Content>
                        <Modal.Actions>
                           <Button negative type="cancel" onClick={() => (dispatch(getAssetList(toast, authToken)), setOpenModal(false))}>
                              Close
                           </Button>
                           <Button
                              content={actionMode === "Edit" ? "Save" : "Create"}
                              type="submit"
                              labelPosition='right'
                              icon='checkmark'
                              loading={isSubmitting}
                              onClick={handleSubmit}
                              positive
                              form="myForm"
                              key="submit"
                              htmlType="submit"
                           />
                        </Modal.Actions>
                     </React.Fragment>
                  )}
               </Formik>
            </Modal>
            <Formik
               enableReinitialize
               initialValues={{
                  id: rowData.id,
                  status: actionMode === 'InActive' ? "I" : actionMode === 'Active' ? "A" : "D"
               }}
               onSubmit={(values, actions) => {
                  actionMode === 'Delete' ?
                     dispatch(deleteAssetList(values, actions, setOpenConfirm, toast, authToken)) :
                     dispatch(statusAssetList(values, actions, setOpenConfirm, toast, authToken))
               }}>
               {({
                  isSubmitting,
                  handleSubmit
               }) => (
                  <ConfirmModal
                     icon="trash alternate outline"
                     color="red"
                     open={openConfirm}
                     cancelText="Cancel"
                     comfirmText="Delete"
                     header={
                        actionMode === 'Delete' ? 'Delete Record' :
                           actionMode === 'InActive' ? 'Inactive Record' :
                              actionMode === 'Active' ? 'Active Rocord' : null
                     }
                     content={
                        actionMode === 'Delete' ? 'Data rocord will lost' :
                           actionMode === 'InActive' ? 'Data record will inactive.' :
                              actionMode === 'Active' ? 'Data record will active?' : null
                     }
                     onCancel={() => setOpenConfirm(false)}
                     onConfirm={handleSubmit}
                     loading={isSubmitting} />
               )}
            </Formik>
         </Container>
      </div>
   )
}

export default AssetList